import axios from 'App/axios';
import { PresignedUrl } from 'commons/types';
import { GetChargebacksResponse } from './chargebackServiceResponses';

const getChargebacks = async () => {
  const response =
    await axios.get<GetChargebacksResponse>(`/admin/chargebacks`);

  return response.data;
};

const generateChargebackS3UploadUrl = async (
  orderId: string,
  contentType: string,
) => {
  const response = await axios.post<PresignedUrl>(
    `/admin/transactions/${orderId}/cbk-receipt-upload/url`,
    {
      contentType,
    },
  );

  return response.data;
};

const sendChargebackDocument = async (orderId: string, key: string) => {
  const response = await axios.post(
    `/admin/transactions/${orderId}/cbk-receipt-upload/finished`,
    {
      key,
    },
  );

  return response.data;
};

const chargebacksService = {
  getChargebacks,
  generateChargebackS3UploadUrl,
  sendChargebackDocument,
};

export default chargebacksService;
